import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { ZERO_VEHICLE_MAP_CLOSEOUT, renderCloseoutBundle } from './closeoutTransportCopy';
import { transportMapMethodology } from './transportMapMethodology';
import {
  buildTransportMapNarrativeTokens,
  type TransportMapNarrativeInput,
} from './transportMapNarrativeTokens';

const CHART_ID = 'transport_map';

export function buildTransportMapAuthoredBundle(input: TransportMapNarrativeInput) {
  const tokens = buildTransportMapNarrativeTokens(input);
  if (input.layerId === 'zero_vehicle_households') {
    const closeout = renderCloseoutBundle(ZERO_VEHICLE_MAP_CLOSEOUT, tokens, {
      chartId: CHART_ID,
      viewId: input.layerId,
    });
    const structured = transportMapMethodology(input.layerId);
    return {
      ...closeout,
      methodology: {
        primarySources: structured.primarySources,
        calculation: structured.calculation,
        limitations: structured.limitations,
        technicalDetails: structured.technicalDetails,
      },
    };
  }
  const structured = transportMapMethodology(input.layerId);
  const fallbackMethodology = {
    primarySources: structured.primarySources,
    calculation: structured.calculation,
    limitations: structured.limitations,
    technicalDetails: structured.technicalDetails,
  };
  return renderAuthoredNarrativeBundle(CHART_ID, input.layerId, tokens, {
    methodology: fallbackMethodology,
  });
}

export function transportMapOverviewDescription(layerId: string, fallback: string): string {
  return getAuthoredOverview(CHART_ID, layerId, fallback);
}

export function buildTransportMapKeyInsights(input: TransportMapNarrativeInput): string {
  const bundle = buildTransportMapAuthoredBundle(input);
  if (bundle.keyInsights) return bundle.keyInsights;
  return `Map data are not available for ${input.locationName}.`;
}

export type { TransportMapNarrativeInput };
